import '../../styles/selfHelp.css';
import { usePhoneDialog } from '../shared/ModalSurface';
import React, { useId } from 'react';
import useSelfHelp from '../../hooks/useSelfHelp';

// BL-177 Step 2d (section 1): the help "?" button -> a small panel with three plain-English lines.
// What it is / Who gets it / When it's sent. `what`, `who`, `when` are strings (Self-Help article text where
// it exists, otherwise a short line). Escape or an outside click closes it.
export default function HelpButton({ title, what, who, when, children, className = '', userId }) {
    const id = useId();
    const help = useSelfHelp(userId);
    const { open, root, trigger, panel, dismiss } = help;
    const onPhoneKeyDown = usePhoneDialog(panel, dismiss, open && !help.canHover, false, help.restoreFocus);
    if (!help.enabled) return null;
    return (
        <span ref={root} {...help.rootProps} className={`relative inline-block ${className}`}>
            <button ref={trigger} {...help.triggerProps} type="button" className="ia-self-help-trigger ia-help-btn" aria-label={title ? `Help: ${title}` : 'Help'} aria-expanded={open} aria-controls={open ? id : undefined}><span className="ia-self-help-circle">?</span></button>
            {open && (
                <span ref={panel} onKeyDown={onPhoneKeyDown} id={id} role="dialog" aria-label={title ? `Help: ${title}` : 'Help'} data-self-help-hover={help.canHover ? "true" : undefined} className="ia-help-panel ia-self-help-panel">
                    <button hidden={help.canHover} type="button" className="ia-modal-close" aria-label="Close help" onClick={dismiss}>×</button>
                    <span className="ia-help-body">
                    {children}
                    {what ? <span className="block"><strong>What it is:</strong> {what}</span> : null}
                    {who ? <span className="mt-2 block"><strong>Who gets it:</strong> {who}</span> : null}
                    {when ? <span className="mt-2 block"><strong>When it&apos;s sent:</strong> {when}</span> : null}
                    </span>
                </span>
            )}
        </span>
    );
}
